var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAncient8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6281_4493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6599 16.1841H1.30396V18.5267H22.6599V16.1841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91605 21.8789L4.22405 23.7175H1.30005L3.34938 18.5269L3.92272 18.8949C4.91605 19.5309 5.32805 20.7749 4.91205 21.8749L4.91605 21.8789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6601 23.7174H19.6214L18.9414 21.9441C18.5068 20.8108 18.9481 19.5308 19.9894 18.9094L20.6214 18.5308L22.6588 23.7214V23.7174H22.6601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6211 18.528H17.6598L16.7731 16.1853L11.9304 3.35467H11.8824L7.05581 16.184L6.17714 18.5267H3.35181L4.27447 16.184L9.45047 3.07467H11.8224L10.6651 0H13.3544L19.7024 16.184L20.6224 18.5267L20.6211 18.528Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6281_4493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAncient8);
export default __webpack_public_path__ + "static/media/ancient8.7ce34aad8f87aacc426a286f02093ff4.svg";
export { ForwardRef as ReactComponent };